<div class="flex justify-center" style="margin-top: 50px; margin-bottom: 50px;">
    <div class="preloader">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
    </div>
</div>